// var UA = require('ua-device');

/**
 * 各种工具函数
 */

/**
 * 是否是数字
 * @param
 * @return {boolean}
 */
var isNumber = function (obj) {
  return Object.prototype.toString.call(obj) === '[object Number]';
}

exports.isNumber = isNumber;

/**
 * 是否是 NaN
 * @param
 * @return {boolean}
 */
exports.isNaN = function isNaN(obj) {
  return isNumber(obj) && obj !== +obj;
}

/**
 * @param {array} array
 * @return {boolean}
 */
exports.isArray = function isArray(arr) {
  if (Array.isArray) {
    return Array.isArray(arr);
  }
  return Object.prototype.toString.call(arr).toUpperCase().indexOf('ARRAY') !== -1;
}

// 空函数
exports.noop = function noop(a) {
  return a || '';
}

/**
 * 合并对象
 */
exports.extend = function extend(obj, src) {
  for (var key in src) {
    if (src.hasOwnProperty(key)) obj[key] = src[key];
  }
  return obj;
}

/**
 * 浅拷贝对象，将对象 b 中所有 a 不存在的 kv 拷贝给 a
 * @param  {Object} obja
 * @param  {Object} objb
 * @param  {Bool}   overwrite  是否覆盖 obja 中已存在的键
 * @return {Object}
 */
exports.shallowMerge = function shallowMerge(obja, objb, overwrite) {
  for (var key in objb) {
    if (objb.hasOwnProperty(key)) {
      if (overwrite || obja[key] === undefined) {
        obja[key] = objb[key];
      }
    }
  }
}

/**
 * 获取页面的 spmA 和 spmB 值，返回对象
 * @return { Object }
 */
exports.getSpm = function getSpm() {
  var spmA = '';
  var spmB = '';
  var goldlog = window.goldlog || {};
  var spmAb = goldlog.spmAb || goldlog.spm_ab;
  /* istanbul ignore if */
  if (spmAb && exports.isArray(spmAb)) {
    spmA = spmAb[0];
    if (spmAb[1]) {
      spmB = spmAb[1];
    }
  }
  return {
    a: spmA,
    b: spmB
  };
}

/**
 * 将 Script error 错误归一化，解决不同浏览器 Script Error 不同的问题
 * @param  {String} msg 报错信息
 * @return {String}
 */
exports.unifyErrorMsg = function unifyErrorMsg(msg) {
  if (/^script error\.?$/i.test(msg)) {
    return 'Script error';
  }

  return msg;
}


/**
 * 获取屏幕尺寸
 * @return {String} 1920x1080
 */
exports.getScreenSize = function getScreenSize() {
  return window.screen.width + 'x' + window.screen.height;
}


/**
 * 根据打点的各个参数生成唯一的标识符，用于判断一次 session 内该错误是否已经打过点
 * @param  {Object} options 打点参数
 * @return {String}
 */
exports.generateIdentifier = function generateIdentifier(options) {
  return [
    options.type,
    options.uid,
    options.page,
    options.msg || '',
    options.ajaxurl || ''
  ].join('_');
}


/**
 * 跨浏览器监听事件
 */
exports.addEvent = function addEvent(elem, event, fn) {
  /* istanbul ignore else */
  if (elem.addEventListener) {
    elem.addEventListener(event, fn, false);
  } else {
    elem.attachEvent('on' + event, function () {
      return fn.call(elem, window.event);
    });
  }
}

function isObject(what) {
  return typeof what === 'object' && what !== null;
}

// Sorta yanked from https://github.com/joyent/node/blob/aa3b4b4/lib/util.js#L560
// with some tiny modifications
exports.isError = function isError(what) {
  var toString = {}.toString.call(what);
  return isObject(what) &&
    toString === '[object Error]' ||
    toString === '[object Exception]' || // Firefox NS_ERROR_FAILURE Exceptions
    what instanceof Error;
}

/*
exports.uaDevice = function uaDevice(ua) {
  if (ua === '') return {};

  var output = new UA(ua);

  var browser = output.browser || {};
  var engine = output.engine || {};
  var os = output.os || {};

  return {
    browser: browser.name + (browser.version || {}).original,
    engine: engine.name + (engine.version || {}).original,
    os: os.name + (os.version || {}).original,
  };
}
*/
